// extracted by mini-css-extract-plugin
export default {"logo":"LogoImage_logo__MgWvG"};